import React from 'react';
import { loginUserRequest, guestUser } from '../../redux/actions/authenticationActions'; // import the actions
import { connect } from 'react-redux'; // need to install  http://redux.js.org/docs/basics/UsageWithReact.html
import {
  injectIntl,
  intlShape,
  FormattedMessage
} from 'react-intl';
import { dashboardData } from '../dashboard/reducer';
import { setCheckout } from '../../lib/helper.js';
import { browserHistory } from 'react-router';
import { updateOrderIdDetails } from '../dashboard/actions';
import defaultMsg from '../../translations/lang/en-US.json';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
    this.emailOnchange = this.emailOnchange.bind(this);
    this.passwordOnchange = this.passwordOnchange.bind(this);
    this.state = {
      email: '',
      password: '',
      signingIn: false,
      redirectingToCheckout: false,
    };
    this.handleForgotPassword = this.handleForgotPassword.bind(this);
  }

  emailOnchange(e) {
    this.setState({
      email: e.target.value,
    });
  }

  passwordOnchange(e) {
    this.setState({
      password: e.target.value,
    });
  }

  handleLogin(e) {
    this.setState({ signingIn: true });
    let object = {
      dataname: this.props.dashboardData.dataName,
      signinname: this.state.email,
      password: this.state.password,
      tokenId: this.props.tokenId,
      jwt: this.props.jwt,
    };
    this.props.dispatch(loginUserRequest(object)).then(res => {
      document.getElementById('user-login').reset();
      this.setState({ signingIn: false });
      if (res.status === 'S') {
        this.props.success(res.message);
        this.props.hideSignInModal();
        if (this.props.signInCaller !== 'header') {
          setCheckout(
            this,
            true,
            function(response) {
              this.props.dispatch(updateOrderIdDetails(response));
              browserHistory.push('/' + this.props.rname + '/checkout');
            }.bind(this)
          );
        }
      } else {
        this.props.error(res.message);
      }
    });
  }

  handleGuest() {
    this.props.dispatch(guestUser());
    if (this.props.signInCaller !== 'header') {
      this.setState({ redirectingToCheckout: true });
      setCheckout(
        this,
        true,
        function(response) {
          this.props.dispatch(updateOrderIdDetails(response));
          this.setState({ redirectingToCheckout: false });
          this.props.hideSignInModal();
          browserHistory.push('/' + this.props.rname + '/checkout');
        }.bind(this)
      );
    } else {
      this.props.hideSignInModal();
    }
  }

  handleForgotPassword() {
    this.props.showForgotPasswordModal('Login');
  }

  render() {

    return (
      <div className="row">
        <div className="col-md-12">
          <form
            id="user-login"
            style={{ display: 'block' }}
            className="form-style"
            onSubmit={e => {
              e.preventDefault();
              this.handleLogin(e);
            }}
          >
            <div className="form-group">
              <label className="customSignLabel">
                <FormattedMessage
                  id="enterEmailAddress"
                  defaultMessage={defaultMsg.enterEmailAddress}
                />
              </label>
              <input
                type="text"
                onChange={this.emailOnchange}
                name="username"
                id="username"
                tabIndex="1"
                className="form-control customInputBox"
                placeholder={this.props.intl.formatMessage({
                  id: 'placeholderEnterEmailAddress',
                  defaultMessage: defaultMsg.placeholderEnterEmailAddress
                })}
                required
              />
            </div>

            <div className="form-group">
              <label className="customSignLabel">
                <FormattedMessage
                  id="enterPassword"
                  defaultMessage={defaultMsg.enterPassword}
                />
              </label>
              <input
                type="password"
                name="password"
                onChange={this.passwordOnchange}
                id="password"
                tabIndex="2"
                className="form-control customInputBox"
                placeholder={this.props.intl.formatMessage({
                  id: 'placeholderEnterPassword',
                  defaultMessage: defaultMsg.placeholderEnterPassword
                })}
                required
              />
            </div>

            <div className="form-group">
              <div className="row">
                <div className="col-lg-12">
                  <button
                    type="button"
                    onClick={this.handleForgotPassword}
                    className="forgot-password olo-client-theme-color btn-link"
                  >
                    <FormattedMessage
                      id="forgotPassword"
                      defaultMessage={defaultMsg.forgotPassword}
                    />
                  </button>
                </div>
              </div>
            </div>

            <div className="form-group">
              <div className="row">
                <div className="col-sm-12 ">
                  <div className="wrapper">
                    {this.state.signingIn === true ? (
                      <button
                        type="button"
                        className="btn btn-default btn-style alignCenter olo-client-theme-background olo-client-theme-border olo-client-theme-color-white"
                      >
                        <FormattedMessage
                          id="signingIn"
                          defaultMessage={defaultMsg.signingIn}
                        />
                      </button>
                    ) : (
                      <button
                        className="btn btn-default btn-style alignCenter olo-client-theme-background olo-client-theme-border olo-client-theme-color-white"
                        type="submit"
                      >
                        <FormattedMessage
                          id="signInButton"
                          defaultMessage={defaultMsg.signInButton}
                        />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {
              <div className="form-group">
                <div className="row">
                  <div className="col-sm-12 ">
                    <div className="wrapper">
                      <p className="strikeLine">
                        <span className="color-or olo-client-theme-color">
                          <FormattedMessage id="or" defaultMessage={defaultMsg.or} />
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            }
          </form>
          <div className="form-group">
            <div className="row">
              <div className="col-sm-12 ">
                <div className="wrapper">
                  {this.state.redirectingToCheckout ? (
                    <button className="btn btn-default alignCenter order-btn inactive">
                      {' '}
                      <FormattedMessage
                        id="redirectingToCheckout"
                        defaultMessage={defaultMsg.redirectingToCheckout}
                      />
                    </button>
                  ) : (
                    <button
                      className="btn btn-default alignCenter order-btn inactive olo-client-theme-background olo-client-theme-border olo-client-theme-color-white"
                      onClick={() => this.handleGuest()}
                    >
                      <FormattedMessage
                        id="orderAsGuest"
                        defaultMessage={defaultMsg.orderAsGuest}
                      />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    errorMessage: state.auth.error,
    message: state.auth.message,
    authenticated: state.auth.authenticated,
    tokenId: state.auth.tokenId,
    jwt: state.auth.jwt,
    dashboardData: dashboardData(state),
  };
}

Login.propTypes = {
  intl: intlShape.isRequired,
};

export default connect(mapStateToProps)(injectIntl(Login));



// WEBPACK FOOTER //
// ./src/views/auth/Login.jsx